const legacyTheme = {
    button: {
        size: {
            small: 40,
            medium: 48
        },
        variant: {
            default: {
                backgroundColor: "rgba(51, 51, 51, 0.2)",
                backgroundColorHovered: "rgba(255, 255, 255, 1)",
                color: "inherit"
            },
            borderOnly: {
                backgroundColor: "rgba(51, 51, 51, 0.2)",
                backgroundColorHovered: "rgba(255, 255, 255, 1)"
            }
        }
    },
    input: {
        valueColor: "#333333",
        valueColorDisabled: "rgba(51, 51, 51, 0.25)",
        labelColor: "rgba(51, 51, 51, 0.5)",
        underlineColor: "rgba(51, 51, 51, 0.5)",
        errorColor: "#f44336"
    },
    checkbox: {
        checkedColor: "#666",
        borderColor: "#989898",
        borderColorFocus: "#333",
        borderColorChecked: "#989898"
    },
    inputSelect: {
        valueColor: "#333333",
        labelColor: "rgba(51, 51, 51, 0.5)",
        underlineColor: "rgba(51, 51, 51, 0.5)",
        iconColor: "rgba(51, 51, 51, 0.5)"
    },
    compactPaymentDisplay: {
        textColor: "#333333",
        iconColor: "#333333",
        paddingLeft: "16px"
    },
    sectionHead: {
        textColor: "rgba(51, 51, 51, 0.75)",
        lineColor: "rgba(51, 51, 51, 0.07)",
        iconColor: "rgba(51, 51, 51, 0.75)"
    }
};
var legacyTheme$1 = legacyTheme;

export { legacyTheme$1 as default };
